import { render, staticRenderFns } from "./Tieba.vue?vue&type=template&id=6858ffaf&"
import script from "./Tieba.vue?vue&type=script&lang=js&"
export * from "./Tieba.vue?vue&type=script&lang=js&"
import style0 from "./Tieba.vue?vue&type=style&index=0&id=6858ffaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports